import { render, staticRenderFns } from "./TargetList.vue?vue&type=template&id=6793c2d0&scoped=true"
import script from "./TargetList.vue?vue&type=script&lang=js"
export * from "./TargetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6793c2d0",
  null
  
)

export default component.exports